var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.834 23.9173H8.16732C4.66732 23.9173 2.33398 22.1673 2.33398 18.084V9.91732C2.33398 5.83398 4.66732 4.08398 8.16732 4.08398H19.834C23.334 4.08398 25.6673 5.83398 25.6673 9.91732V18.084C25.6673 22.1673 23.334 23.9173 19.834 23.9173Z",
    fill: "#76C6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5C15.933 17.5 17.5 15.933 17.5 14C17.5 12.067 15.933 10.5 14 10.5C12.067 10.5 10.5 12.067 10.5 14C10.5 15.933 12.067 17.5 14 17.5Z",
    fill: "#023061"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41602 17.7923C5.93768 17.7923 5.54102 17.3957 5.54102 16.9173V11.084C5.54102 10.6057 5.93768 10.209 6.41602 10.209C6.89435 10.209 7.29102 10.6057 7.29102 11.084V16.9173C7.29102 17.3957 6.89435 17.7923 6.41602 17.7923Z",
    fill: "#023061"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.584 17.7923C21.1057 17.7923 20.709 17.3957 20.709 16.9173V11.084C20.709 10.6057 21.1057 10.209 21.584 10.209C22.0623 10.209 22.459 10.6057 22.459 11.084V16.9173C22.459 17.3957 22.0623 17.7923 21.584 17.7923Z",
    fill: "#023061"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLender);
export default __webpack_public_path__ + "static/media/lender.99bfa23eb594ccf66686c4acf7664231.svg";
export { ForwardRef as ReactComponent };